let aZipCode;
let aState;
let aSearchType;
let aSearchInput;
let searchBtnClicked;
let aSearchTypeCode;
// Add searchChanged to let MLSearchResults know search type changed and will re-render datatable in MLSearchResults
let searchChanged;

export default {
    setZipCode(zipCode) {
        aZipCode = zipCode;
    },

    getZipCode() {
        return aZipCode;
    },

    setState(state) {
        aState = state;
    },

    getState() {
        return aState;
    },

    setSearchType(searchType) {
        aSearchType = searchType;
    },

    getSearchType() {
        return aSearchType;
    },

    setSearchTypeCode(searchTypeCode) {
        aSearchTypeCode = searchTypeCode;
    },

    getSearchTypeCode() {
        return aSearchTypeCode;
    },

    setSearchInput(input) {
        aSearchInput = input;
    },

    getSearchInput() {
        return aSearchInput;
    },

    setSearchBtnClicked(input) {
        searchBtnClicked = input;
    },

    getSearchBtnClicked() {
        return searchBtnClicked;
    },

    setSearchTypeChanged(input) {
        searchChanged = input
    },

    getSearchTypeChanged() {
        return searchChanged;
    },

    clear() {
        aZipCode = undefined;
        aState = undefined;
        aSearchInput = undefined;
        searchBtnClicked = undefined;
    }
};
